import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {default as RubroListado} from '../../components/Rubro/rubrosList'
import { swapRubros, sagaGetRubros, saveRubro, sagaEliminiarRubro, sagaRevertirRubro } from '../../reducers/rubrosReducer/actions'
import {rubrosDataSelector} from '../../selectors/rubrosSelector'
import { usuarioSelector } from '../../selectors/sessionSelector'

class RubroContainer extends React.Component {

    constructor(props) {
        super(props)
        this.state= {
            nombre: "",
            tipoUsuario: null,
            estado: null,
            localidad: "",
            noHabilitados: true,
            noConfirmados: true,
            modalData:{
                openModal: false,
                mensaje: "Está por eliminar un rubro",
                labelModalOk: "Eliminar",
                handleModalOk: ()=>{},
                handleCloseModal: ()=>{},
            },
            usuarioCargado: false
        }
        // busco los datos iniciales
        this.busqueda()
    }

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                }
            })
        }
    }

    busqueda(){
        this.props.sagaGetRubros(this.state.nombre, false,false);
        this.props.saveRubro(undefined);
    }

    render() {
        return <RubroListado 
        rubros={this.props.rubros.rubros}
        mapToItem={(x)=>({
            nombre:x.nombre, 
            habilitado: x.habilitado || x.tipoRol === 1 ,
            confirmado: x.confirmado, 
            activo: x.activo,
            orden: x.orden,
            onClick:  (x.activo)?()=>{ this.props.saveRubro(x);this.props.history.push("/Rubros/Edit/"+x.idRubro) }:undefined,
            opciones:
            [(x.activo)?{nombre:"Editar",handler:()=>{ this.props.saveRubro(x);this.props.history.push("/Rubros/Edit/"+x.idRubro) }}:undefined,
             (x.activo)?{nombre:"Subrubros",handler:()=>{this.props.history.push("/SubRubros/"+x.idRubro+"/"+x.nombre)}}:undefined,
            {nombre:(x.activo)?"Eliminar":"Revertir",handler:()=>{ 
                (x.activo)?
                this.setState(
                {modalData:{
                    openModal: true,
                    mensaje:`Esta por eliminar el rubro ${x.nombre}`,
                    labelModalOk: "Eliminar",
                    handleModalOk: ()=>{this.props.sagaEliminiarRubro(x.idRubro); this.setState({modalData:{openModal:false}});},
                    handleCloseModal: ()=>{this.setState({modalData:{openModal:false}})},
                }}):
                this.setState(
                    {modalData:{
                        openModal: true,
                        mensaje:`Esta por reactivar el rubro ${x.nombre}`,
                        labelModalOk: "Reactivar",
                        handleModalOk: ()=>{this.props.sagaRevertirRubro(x.idRubro); this.setState({modalData:{openModal:false}});},
                        handleCloseModal: ()=>{this.setState({modalData:{openModal:false}})},
                    }})
             }}],
            imagen: (x.imagen)?x.imagen:require('../../images/default_rubro.png'),
        })}
        handleOnSwap={(from, to)=>{this.props.swapRubros(from, to)}}
        handleOnSave={()=>{}}
        handleOnSearch={(nombre)=>{
            this.setState({nombre:nombre},()=>{this.busqueda()})
        }}
        canSwap={this.state.nombre === ""}
        {...this.state.modalData}
    />
    }
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
        swapRubros, sagaGetRubros, saveRubro, sagaEliminiarRubro, sagaRevertirRubro
	}, dispatch)
}

function mapStateToProps(state) {
	return {
        rubros: rubrosDataSelector(state),
        usuario: usuarioSelector(state),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(RubroContainer)